/* eslint-disable import/no-named-as-default */
import Agency from 'modules/agency';
import AgencyLogin from 'modules/agency/components/Login';
import Faqs from './Faqs';
import StaticPages from './StaticPages';
import Locations from './Locations';
import Trips from './Trips';
import Payments from './Payments';
import PaymentMethods from './PaymentMethods';
import Users from './Users';
import Tickets from './Tickets';
import Cities from './Cities';
import Marketing from './sendgridv3/Marketing';
import DiscountCode from './DiscountCode';
import { Subscription } from './Subscription';
import NextAvailableTrips from './NextAvailableTrips';
import TopDestinations from './TopDestination';
import Checkout from './Checkout';
import QRCode from './QRCode';
import PaymentData from './PaymentData';
import setCustomer from './setCustomer';
import Calendar from './Calendar';
import Banners from './Banners';
import Routes from './Routes';
import Reports from './Reports';
import Rebooking from './rebooking';

import TripsOld from './TripsOld';
import Settings from './Settings';
import Pinpad from './Pinpad';

export enum AppViews {
  HOME = '/',
  HELP = '/help',
  STATIC_PAGE = '/page',
  ROADMAP = '/page/roadmap',
  STOPS_INFO = '/stops-information',
  FAQS = '/faqs',
  SEARCH = '/search',
  CHECKOUT = '/checkout',
  PAYMENT_LANDING_PAGE = '/payment_status',
  PAYMENT_PENDING = '/payment_pending',
  SIGN_IN = '/sign_in',
  SIGN_UP = '/sign_up',
  SIGN_IN_MOBILE = '/sign_in_mobile',
  CONFIRMATION = '/confirmation',
  SIGN_UP_COMPLETED = '/sign_up_completed',
  FORGOT_PASSWORD = '/forgot_password',
  MANAGE_YOUR_BOOKING = '/manage_your_booking',

  BOOKINGS = '/manage_your_booking/bookings',
  CANT_MANAGE = '/manage_your_booking/cant_manage',
  ALTER_TRIP = '/manage_your_booking/alter_trip',
  CHECKOUT_ALTER = '/manage_your_booking/alter_trip/checkout',

  USER_BOOKINGS = '/users/bookings',
  USER_PROFILE = '/users/profile',
  USER_PAYMENT_METHODS = '/users/payment_methods',
  USER_ADD_PAYMENT_METHODS = '/users/payment_methods/add',

  AGENCY = '/agency',
  AGENCY_LOGIN = '/agency/auth',
  AGENCY_REPORTS = '/agency/reports',
  AGENCY_NEW_REPORTS = '/agency/new_reports',

  BOOKING_COUPON = '/bookingcoupon',
  AGENCY_TICKETS = '/agency/tickets',
  AGENCY_PAYMENTS = '/agency/payments',
  AGENCY_SETTINGS = '/agency/settings',
  MAPS = '/maps',
  DETAIL_412 = '/detail412',
}

const Endpoints = {
  ...Faqs,
  ...StaticPages,
  ...Marketing,
  ...Locations,
  ...Trips,
  ...Payments,
  ...PaymentMethods,
  ...Users,
  ...Tickets,
  ...Cities,
  ...DiscountCode,
  ...Subscription,
  ...NextAvailableTrips,
  ...TopDestinations,
  ...Checkout,
  ...QRCode,
  ...PaymentData,
  ...setCustomer,
  ...Calendar,
  ...Banners,
  ...Routes,
  ...Rebooking,
  ...Agency,
  ...AgencyLogin,
  ...Reports,
  ...TripsOld,
  ...Settings,
  ...Pinpad,
};

export default Endpoints;
